import { useEffect, useState } from 'react';
import { hoverSupportMedia } from '../../constants';
import { isBrowser } from '../utils';
export const useSupportsHover = ({ ssr = true } = {}) => {
    const [supportsHover, setSupportsHover] = useState(() => {
        if (!ssr && isBrowser && window && window.matchMedia) {
            return window.matchMedia(hoverSupportMedia).matches;
        }
        return null;
    });
    useEffect(() => {
        const handleMqlChange = (event) => {
            setSupportsHover(event.matches);
        };
        if (ssr) {
            handleMqlChange(window.matchMedia(hoverSupportMedia));
        }
        const mql = window.matchMedia(hoverSupportMedia);
        mql.addEventListener('change', handleMqlChange);
        return () => mql.removeEventListener('change', handleMqlChange);
    }, [ssr]);
    return supportsHover;
};
//# sourceMappingURL=useSupportsHover.js.map